<template>
  <div class="animated fadeIn setting-container step-container" v-if="loaded">
    <div class="row">
      <div class="col-md-8 offset-md-2 alert-container-padding-zero">
        <alertbar/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">{{$t('message.settings.title')}}</h4>
        <h6>{{$t('message.settings.feedback')}}</h6>

        <div class="row">
          <div class="col-12">
            
            <div class="form-group">
              
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="doctor.show_review">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name">{{$t('message.settings.show_feedback')}}</label>
            </div>
            <div class="form-divider"></div>
          </div>

        </div>

        <h6>{{$t('message.settings.search')}}</h6>
        <div class="row">
          <div class="col-12">
            <div class="form-group premium-feature" :class="{ 'disable': !$guser.isPremiumAccount() }">
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="doctor.search_active" :disabled="!$guser.isPremiumAccount()">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name">{{$t('message.settings.search_display')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!$guser.isPremiumAccount()"></i></label>

            </div>
            <div class="form-divider"></div>
          </div>

        </div>

        <div class="row">
          <div class="col-12 form-group">
            <button class="btn btn-store btn-lg" @click="save">{{$t('action_message.save')}}</button>
            <div slot='loader' v-show='loading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div>
          </div>
        </div>
      </div>
    </div>
    <sweet-modal icon="success" ref="modal"> </sweet-modal>
  </div>
</template>

<script>

import Alertbar from '@/components/AlertBar'
import SyncLoader from 'vue-spinner/src/SyncLoader'
import VueTimepicker from 'vue2-timepicker'
import { input as BsInput } from 'vue-strap'
import { SweetModal } from 'sweet-modal-vue'
import DoctorArrayInput from '@/components/DoctorArrayInput'

export default {
  components: {
    Alertbar,
    SyncLoader,
    SweetModal,
    VueTimepicker,
    BsInput,
    DoctorArrayInput
  },
  data () {
    let doctorDefault = {
      show_review: 0
    }
    return {
      clinic: Object.assign({}, doctorDefault),
      loading: true,
      loaded: false
    }
  },
  methods: {
    async loadSetting () {
      let response = await this.$http.get(this.$APP_CONFIG.api.admin.doctorme(), { credentials: true })
      if (response) {
        this.processDoctor(response.body.data)
      }
      this.loading = false
      this.loaded = true
    },
    processDoctor (data) {
      this.doctor = Object.assign({}, this.doctor, data)
    },
    save () {
      this.loading = true
      let updatedDoctor = {
        show_review: this.doctor.show_review ? 1 : 0
      }

      this.$http.put(this.$APP_CONFIG.api.admin.doctorme(),
        updatedDoctor,
        {headers: { 'content-type': 'application/json' }})
        .then(res => {
          this.loading = false
          if (res.body.status === 'success') {
            this.processDoctor(res.body.data)
            this.$refs.modal.open()
          }
        })
    }
  },
  created () {
    this.loadSetting()
  }
}
</script>

<style lang="scss">
@import "../../assets/base_container";
.setting-container{
  .switch{
    margin-right: 10px;
  }
  .premium-feature.disable{
    .switch-label{
      background-color: #a2a0a0 !important;
      border-color: #a2a0a0;
    }
    .switch-name{
      color: #a2a0a0;
    }
    .switch-handle{
      border-color: #a2a0a0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Setting.vue?3abb026e